import { createSlice } from '@reduxjs/toolkit';

const cartSlice = createSlice({
    name: 'cart',
    initialState: {
        cartId: null,
        checkoutUrl: null,
        lines: [],        // [{ variantId, title, price, currency, image, quantity }]
        loading: false,
        error: null,
        toast: null
    },
    reducers: {
        SET_CART: (state, action) => {
            return {
                ...state,
                cartId: action.payload.cartId,
                checkoutUrl: action.payload.checkoutUrl,
                lines: action.payload.lines,
            };
        },
        SET_CART_LOADING: (state, action) => {
            return { ...state, loading: action.payload };
        },
        SET_CART_ERROR: (state, action) => {
            return { ...state, error: action.payload };
        },
        CLEAR_CART: () => {
            return { cartId: null, checkoutUrl: null, lines: [], loading: false, error: null };
        },
        SET_TOAST: (state, action) => {
            return { ...state, toast: action.payload };
        },
        CLEAR_TOAST: (state) => {
            return { ...state, toast: null };
        }
    },
});

export const { SET_CART, SET_CART_LOADING, SET_CART_ERROR, CLEAR_CART, SET_TOAST, CLEAR_TOAST } = cartSlice.actions;
export default cartSlice.reducer;
